import Skeleton from "react-loading-skeleton";

function QuantitySelectSection({
  localLoading,
  quantity,
  setQuantity,
  selectedSize
}) {
  return (
    <div className={`quantity-selector Qunatity-m001 ${quantity === 0 ? "d-none" : ""}`}>
      <p style={{ marginBottom: "0" }}>{localLoading ? <Skeleton width={100} /> : "Quantity"}</p>
      <div className="qty-control">
        {localLoading ? (
          <Skeleton width={100} height={40} />
        ) : (
          <>
            <button onClick={() => setQuantity((q) => Math.max(1, q - 1))}>
              −
            </button>
            <span className="order_track_count">{quantity}</span>
            <button
              className="qty-inc"
              onClick={() => setQuantity((q) => q + 1)}
              disabled={quantity >= selectedSize?.stock}
            >
              +
            </button>
          </>
        )}
      </div>
    </div>
  );
}

export default QuantitySelectSection;
